export default __webpack_public_path__ + "static/media/366.756c666d.jpg";